/* eslint-disable @typescript-eslint/no-unused-vars */
import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import type { MotivationalTextDto } from '@/application/interfaces/pegasus.gateway';
import { MixpanelEssayTopic, Tracking } from '@/application/utils/tracking';
import { EssayStore } from '@/presentation/stores/essay.store';

import IconComponent from '../../../../components/icon/icon';
import { EssayViewModel } from '../../essay.vm';
import { Card, ContentWrapper, DetailsButton, TagWrapper, Title, TitleWrapper } from './styles';

type Props = {
  themeGuid: string;
  themeOrigin: string;
  themeTitle: string;
  exampleEssay?: string;
  themeCover: string;
  motivationalTexts?: MotivationalTextDto[];
};

const trackinClickTopicEvent = (topic: any) => {
  const props: MixpanelEssayTopic = {
    user: topic.name,
    student_id: topic.student_id,
    email: topic.email,
    topicGuid: topic.topicGuid,
    topicName: topic.topicName,
    isHighlight: topic.isHighlight,
    studentClassGuid: topic.studentClassGuid,
    studentClassTags: topic.studentClassTags,
    studentClassTitle: topic.studentClassTitle,
  };
  Tracking.topicEssayCardClick(props);
};

const ThemeItem: React.FC<Props> = ({
  themeGuid,
  themeOrigin,
  themeTitle,
  themeCover,
  exampleEssay,
  motivationalTexts,
}) => {
  const vm = useViewModel(EssayStore);
  const essayVm = useViewModel(EssayViewModel);
  const navigate = useNavigate();

  return (
    <Card>
      <ContentWrapper backgroundUrl={themeCover}>
        <TagWrapper>
          <span>{themeOrigin}</span>
        </TagWrapper>
      </ContentWrapper>
      <TitleWrapper>
        <Title>{themeTitle}</Title>
      </TitleWrapper>
      <DetailsButton
        type="button"
        onClick={async () => {
          await vm.setCurrentTheme({
            id: themeGuid,
            name: themeTitle,
            imageUrl: themeCover,
            motivationalTexts: motivationalTexts || [],
            isHighlight: false,
          });

          trackinClickTopicEvent({
            name: vm.user.name,
            student_id: vm.user.guid,
            email: vm.user.email,
            topicGuid: themeGuid,
            topicName: themeTitle,
            topicImageUrl: themeCover,
            isHighlight: false,
            studentClassGuid: vm.currentStudentClass?.guid || '',
            studentClassTags: vm.currentStudentClass?.tags || '',
            studentClassTitle: vm.currentStudentClass?.title || '',
          });

          essayVm.isEssayTypeModalOpen = true;
        }}
      >
        Escrever redação
        <IconComponent name="whiteArrow" />
      </DetailsButton>
    </Card>
  );
};

export default ThemeItem;
